<template>
  <ul class="navbar-nav ml-auto">
    <li class="nav-item dropdown no-arrow">
      <!-- <span class="font-grap small"><i class="far fa-clock"></i></span> -->
      <!-- <span class="font-grap small">{{ viewDate }}</span> -->
      <b-dropdown class="mr-2" variant="link">
        <template v-slot:button-content>
          <span class="mr-2 font-grap small">{{ data.info.name || '管理員' }}</span>
          <!-- <img
            class="img-profile rounded-circle"
            :src="data.headImage"
            :alt="data.name"
          /> -->
        </template>
        <b-dropdown-item @click="logout()">登出</b-dropdown-item>
      </b-dropdown>
    </li>
  </ul>
</template>

<script>
import baseApi from "@/models/API/baseApi";
import { removeLocalUserInfo, getLocalUserInfo } from "@/models/HELPERS/common.js";

export default {
  name: "TopbarNavbar",
  data() {
    return {
      data: {
        date: new Date(),
        info: {}
      }
    };
  },
  computed: {
    //顯示時間日期
    viewDate() {
      let date = new Date(this.data.date);
      let year = date.getFullYear();
      let month = this.padDate(date.getMonth()+1);
      let day = this.padDate(date.getDate());
      let hours = this.padDate(date.getHours());
      let minutes = this.padDate(date.getMinutes());
      let seconds = this.padDate(date.getSeconds());
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    }
  },
  created() {
    //每秒更新，修改數據date
    this.timer = setInterval(() =>{
      this.data.date = new Date();
    },1000);

    this.load();
  },
   mounted() {
    this.baseApi = new baseApi();
  },
  beforeDestroy() {
    //在Vue實例銷毀前，清除定時器
    if(this.timer){
      clearInterval(this.timer);
    }
  },
  methods: {
    async load() {
      const meta = this.$route.meta;
      this.data.info = getLocalUserInfo(meta.authority);
    },
    padDate(value) {
      return value <10 ? '0' + value:value;
    },
    logout() {
      if (confirm('確定登出?')){
        this.baseApi.authLogout((response) => {
          removeLocalUserInfo(this.data.info.authority);
          this.$router.push('/login');
        })
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layouts/TopbarNavbar.vue